<template>
  <b-container>

    <b-col class="text-left" v-if="shortCreateFormComputed">
      <m-a :href="{name:'ProductsDashboard'}">
        <b-button pill variant="purple" class="ml-1 mb-1">
          محصولات
        </b-button>
      </m-a>
      <m-a :href="{name:'StoreDashboardProducts'}">
        <b-button pill variant="purple" class="ml-1 mb-1">
          محصولات انبار
        </b-button>
      </m-a>


      <template v-if="checkBasalamShowConfigButton">
        <m-a :href="{name:'productBasalamSetting',params:{id:$route.params.slug}}">
          <b-button pill variant="purple" class="ml-1 mb-1">
            تنظیمات باسلام
          </b-button>
        </m-a>
      </template>

    </b-col>

    <b-form @submit.prevent="onSubmit">
      <h5>{{ title }}</h5>

      <name-and-link-manager
          :router-link="{ name: 'Product', params: { name: form.nameAndLink.link } }"
          :label="'نام محصول'"
          v-model="form.nameAndLink"
          :validation="$v.form.nameAndLink.name">

        <published-checkbox v-if="shortCreateFormComputed" label="وضعیت انتشار" v-model="form.published"/>

      </name-and-link-manager>

      <span class="mt-3 d-inline-block" v-if="$route.params.slug != undefined && shortCreateFormComputed"
            @click="copyToClipBoard(`${findAttributeOnSiteInfo('host')[0]}/api/s/p-${form.id}`)">
        لینک کوتاه
        <b-icon-link45deg/>
      </span>


      <div class="my-3" v-if="$route.params.slug != undefined">
        <qr-generator
            :qr-value="dashboardLinkToSiteLink('Product',{name:form.nameAndLink.link})"/>
      </div>


      <b-row class="mt-5" v-if="shortCreateFormComputed">

        <published-checkbox label="محصول دیجیتال است؟" v-model="form.is_digital"/>
      </b-row>

      <b-row class="mt-5 mb-2">عکس های محصول</b-row>
      <b-row>
        <!--   select multiple image and show their preview   -->
        <b-col sm="12" md="12">
          <multi-image-input @removeImage="removeImage" @removeTempImage="removeTempImage" @images="setImages"
                             :previews="form.preview"/>
        </b-col>

        <b-col sm="12" md="12">
          <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                        :validation="$v.form.mainImage"></single-image>

        </b-col>


      </b-row>

      <b-row class="mt-5">مشخصات محصول</b-row>
      <b-row class="mt-2">
        <brand v-if="shortCreateFormComputed"
               :brands="brands" v-model="form.selectedBrand"
               :validation="$v.form.selectedBrand"
        />

        <languageBox :class="{'d-none':!shortCreateFormComputed}" v-model="form.language_id"
                     :validation="$v.form.language_id"/>
      </b-row>
      <b-row>
        <check-box-manager v-if="shortCreateFormComputed" :CheckBoxItems="categories" label="انتخاب دسته بندی"
                           :selectedCheckBoxes="form.selectedCategory" :validation="$v.form.selectedCategory"/>
      </b-row>

      <b-row class="mt-5">
        <b-col md="2" v-if="form.variation==0">
          <form-input :custom_class_on_input="`text-left`" v-model="form.price" label="قیمت"
                      :validation="$v.form.price"/>
          <span v-if="form.price">{{ formatNumber(form.price) }}</span>
        </b-col>
        <b-col md="2" v-if="form.variation==0">
          <form-input :custom_class_on_input="`text-left`" v-model="form.quantity" label="تعداد موجود در انبار"
                      :validation="$v.form.quantity"/>
          <span class="d-block" v-if="form.quantity">{{ formatNumber(form.quantity) }}</span>
          <span
              style="font-size: 14px">نکته: در صورت خالی گذاشتن این بخش "تعداد موجودی" بینهایت در نظر گرفته میشود.</span>
        </b-col>
        <b-col md="2" v-if="!form.is_digital && shortCreateFormComputed">
          <form-input :custom_class_on_input="`text-left`" v-model="form.shippingCost" label="هزینه ارسال"
                      :validation="$v.form.shippingCost"/>
          <span class="d-block" v-if="form.shippingCost">{{ formatNumber(form.shippingCost) }}</span>
          <span
              style="font-size: 14px">در صورت تغییر ندادن این بخش هزینه ارسال از بخش تنظیمات، برای سفارش تنظیم میشود.</span>
        </b-col>
        <b-col md="2" v-if="form.variation==0 && shortCreateFormComputed">
          <form-input :custom_class_on_input="`text-left`" v-model="form.discount" label="تخفیف"
                      :validation="$v.form.discount"
                      @input="calculatePercentOfDiscount"/>
          <span class="d-block" v-if="form.discount">{{ formatNumber(form.discount) }}</span>
        </b-col>

        <b-col md="2" v-if="shortCreateFormComputed">
          <form-input :custom_class_on_input="`text-left`" v-model="form.bonus" label="پرداخت اضافی"
                      :validation="$v.form.bonus"/>
          <span class="d-block" v-if="form.bonus">{{ formatNumber(form.bonus) }}</span>
        </b-col>
        <b-col md="2" v-if="shortCreateFormComputed">
          <form-input :custom_class_on_input="`text-left`" v-model="form.order" label="ترتیب"
                      :validation="$v.form.order"/>
          <span class="d-block" v-if="form.order">{{ formatNumber(form.order) }}</span>
          <span
              style="font-size: 14px">برای وارد کردن عدد دلخواه شروع را از 2 در نظر بگیرید.</span>
        </b-col>
        <b-col md="2">
          <form-input v-model="form.barcode" label="بارکد"
                      :validation="$v.form.barcode"/>
        </b-col>

        <!-- فیلد محاسبه درصد تخفیف -->
        <b-col md="2" v-if="form.variation===0 && shortCreateFormComputed">
          <form-input
              :validation="$v.form.discountPercentage"
              :custom_class_on_input="`text-left`"
              v-model="form.discountPercentage"
              @input="calculateDiscount"
              label="درصد تخفیف"
          />

        </b-col>


      </b-row>


      <b-row class="mt-5" v-if="shortCreateFormComputed">

        <form-group :validations="$v.form.description" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>توضیحات</label>
            <b-row>
              <b-col lg="4">
                <add-iframe-to-editor @iframe-handler="iframeHandlerFunction"/>
              </b-col>
            </b-row>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.description" :options="defaultToolbar"></vue2-tinymce-editor>

            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-row>

      <b-row v-if="shortCreateFormComputed">
        <b-col>
          <label :for="`variation`">نوع محصول</label>
          <select class="custom-select d-block col-4" :disabled="$route.params.slug != undefined"
                  v-model="form.variation" @change="variationSwitchChange">
            <option value="0">معمولی</option>
            <option value="1">متغیر</option>
            <option value="2">زمان دار</option>
          </select>
          <p>فقط در زمان ساخت محصول امکان انتخاب نوع محصول امکان پذیر است.</p>

          <b-button variant="danger mt-2" v-if="form.variation == 1 " pill v-b-modal.variation-product>اضافه کردن
            متغییر
          </b-button>
        </b-col>
      </b-row>

      <b-modal id="variation-product" hide-footer size="lg" dir="rtl">
        <variation-feature-generator :product="form"/>
      </b-modal>

      <features-manager v-if="showFeatureManager && shortCreateFormComputed" :product="form" :features="form.features"/>

      <key-words-manager v-if="shortCreateFormComputed" :keyWords="form.keyWords" :TableItems="form.table"/>

      <!-- reservation -->
      <reservation v-if="form.variation == 2 && this.$route.params.slug !== undefined" :product="form.id"
                   :reservationRule="reservationRule" :reservationTimes="reservationTimes"/>
      <!-- reservation -->


      <!--  bulk start    -->

      <div class="" v-if="form.variation == 0 && this.$route.params.slug !== undefined">
        <b-button class="w-25 my-3" v-b-toggle.bulk
                  variant="info" pill>محدودیت فروش
        </b-button>
        <b-button variant="info" v-b-modal.create-bulk class="rounded-pill mx-2">+</b-button>
      </div>

      <b-collapse id="bulk" class="mt-2">


        <table class="table text-center">
          <thead>
          <tr>
            <th scope="col">شروع بازه</th>
            <th scope="col">پایان بازه</th>
            <th scope="col">قیمت</th>
            <th scope="col">تخفیف</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>
          <bulk-item v-for="item in bulks" :key="item.id" :item="item"/>

          </tbody>
        </table>

      </b-collapse>

      <b-modal id="create-bulk" hide-footer>
        <div class="text-right">
          <bulk-form :product_id="form.id"/>
        </div>
      </b-modal>


      <!--  bulk end    -->


      <!--  crawler start   -->
      <div class="" v-if="this.$route.params.slug !== undefined">
        <b-button class="w-25 my-3" v-b-toggle.crawler
                  variant="secondary" pill>crawler
        </b-button>
        <b-button v-b-modal.create-crawler class="rounded-pill mx-2">+</b-button>
      </div>

      <b-modal id="create-crawler" hide-footer>
        <div class="text-right">
          <crawler-form crawler-type="product" :product="form" :crawlerable-id="form.id"/>
        </div>
      </b-modal>

      <b-collapse id="crawler" class="mt-2">


        <table class="table text-center">
          <thead>
          <tr>
            <th scope="col">لینک</th>
            <th scope="col">xpath</th>
            <th scope="col">محل قرارگیری</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>
          <crawler-item v-for="item in crawlers" :key="item.id" :product="form" :item="item"/>

          </tbody>
        </table>

      </b-collapse>
      <!--  crawler end   -->


      <b-row class="my-5" v-if="shortCreateFormComputed">

        <b-button pill type="submit" variant="purple" class="px-5  m-2  col ">
          ثبت
        </b-button>

        <b-button v-if="this.$route.params.slug == undefined" @click="submitAndCreateNew()" pill type="button"
                  variant="purple" class="    col px-5 m-2">
          ثبت و ساخت جدید
        </b-button>

      </b-row>

      <b-row class="my-5" v-else>

        <b-button v-if="this.$route.params.slug == undefined" pill type="submit"
                  variant="purple" class="    col px-5 m-2">
          ثبت و ساخت جدید
        </b-button>

      </b-row>

    </b-form>
  </b-container>
</template>
<script>
import {mapGetters} from "vuex";
import router from '@/router';
import {required, numeric, minValue, maxValue, integer} from "vuelidate/lib/validators";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import category from "./category";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import SingleImage from "../Content/FormItems/SingleImage.vue";
import RadioBox from "../Content/FormItems/RadioBox.vue";
import CheckBoxManager from "../Content/FormItems/CheckBoxManager.vue";
import FormInput from "../Content/FormItems/FormInput.vue";
import FormTextArea from "../Content/FormItems/FormTextArea.vue";
import FeaturesManager from "../Content/FormItems/FeaturesManager.vue";
import KeyWordsManager from "../Content/FormItems/KeyWordsManager.vue";
import NameAndLinkManager from "../Content/FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "../Content/FormItems/PublishedCheckbox.vue";
import VariationFeatureGenerator from "./productFeatureComponents/VariationFeatureGenerator.vue";
import AddIframeToEditor from "../Content/FormItems/AddIframeToEditor";
import Brand from './Brand'
import MultiImageInput from './MultiImageInput'
import CrawlerItem from '../Crawler/CrawlerItem'
import CrawlerForm from '../Crawler/CrawlerForm'
import BulkItem from '../Bulk/BulkItem'
import BulkForm from '../Bulk/BulkForm'
import languageBox from "../Language/LanguageBox";
import {Vue2TinymceEditor} from "vue2-tinymce-editor";
import Reservation from "../Reservation/Reservation.vue";

import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import QrGenerator from "@/plugin/components/genralComponents/QrGenerator.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "CreateProductLayout",
  components: {
    VariationFeatureGenerator,
    QrGenerator,
    category,
    FormGroup,
    FormErrorsManager,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    FeaturesManager,
    KeyWordsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    Brand,
    MultiImageInput,
    CrawlerItem,
    CrawlerForm,
    BulkItem,
    BulkForm,
    languageBox,
    AddIframeToEditor,
    Vue2TinymceEditor,
    Reservation,
  },
  props: {
    title: {},
    submitFunction: {},
    shortCreateForm: {
      default: false
    },
  },
  data() {
    return {
      showFeatureManager: true,
      featureVariation: [],
      selectedFeatureVariation: [],
      form: {
        images: [],
        mainImage: [],
        mainPreview: "",
        preview: [],
        selectedBrand: "",
        selectedCategory: [],
        selectedFeature: [],
        price: null,
        quantity: null,
        shippingCost: null,
        discount: null,
        published: false,
        description: "",
        id: "",
        keyWords: [],
        nameAndLink: {name: "", link: ""},
        is_digital: false,
        variation: 0,
        bonus: 0,
        order: 0,
        language_id: '',
        barcode: '',
        table: [],
        features: [],
        discountPercentage: 0,
      },
      defaultToolbar,
    };
  },
  validations() {
    if (this.shortCreateForm) {
      return {
        form: {
          nameAndLink: {name: {required}},
          selectedBrand: {},
          selectedCategory: {},
          items: {},
          price: {numeric},
          quantity: {numeric},
          shippingCost: {numeric},
          discount: {numeric},
          bonus: {numeric},
          order: {numeric, minValue: minValue(0)},
          language_id: {required},
          barcode: {},
          description: {},
          variation: {},
          mainImage: {},
          discountPercentage: {numeric, minValue: minValue(0), maxValue: maxValue(100)},
        }
      }
    }

    return {
      form: {
        nameAndLink: {name: {required}},
        selectedBrand: {},
        selectedCategory: {},
        items: {},
        price: {numeric},
        quantity: {numeric},
        shippingCost: {numeric},
        discount: {numeric},
        bonus: {required, numeric},
        order: {required, numeric, minValue: minValue(0)},
        language_id: {required},
        barcode: {},
        description: {},
        variation: {},
        mainImage: {},
        discountPercentage: {minValue: minValue(0), maxValue: maxValue(100)},
      }
    }
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
      brands: "Brand/getBrands",
      features: "Feature/getFilteredFeatures",
      crawlers: "Crawler/getCrawlers",
      bulks: "Bulk/getBulks",
      reservationRule: "Reservation/getReservationRule",
      reservationTimes: "Reservation/getReservationTimes",
    }),
    shortCreateFormComputed() {
      return !this.shortCreateForm
    },
    checkBasalamShowConfigButton() {
      return this.$route.params.slug !== undefined && findAttributeOnSiteInfo('basalam_token')[0] != ''
    }
  },
  methods: {
    formatNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.shortCreateForm) {
        this.submitAndCreateNew()
        return false
      }
      this.submitAndPush()
    },
    submitAndPush() {
      if (this.invalid()) {
        let form = {};

        form = {
          name: this.form.nameAndLink.name,
          link: this.form.nameAndLink.link,
          ...this.form,
        };
        this.submitFunction(form)
            .then((res) => {
              const product = res.data.data;
              if (this.$router.currentRoute.params.slug !== product.raw_link) {
                router.push({
                  name: "EditProduct",
                  params: {slug: product.raw_link},
                });
              }
              if (this.$route.params.slug !== undefined) {
                this.setComponentForm('all')
                this.$store.commit("Product/setProduct", product);
              }
              toast('محصول با موفقیت ثبت شد.', 'محصول با موفقیت ثبت شد.', 'success', 'top-left')
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    submitAndCreateNew() {
      if (this.invalid()) {
        let form = {};


        form = {
          name: this.form.nameAndLink.name,
          link: this.form.nameAndLink.link,
          ...this.form,
        };

        this.submitFunction(form)
            .then((res) => {
              const product = res.data.data;
              toast('محصول با موفقیت ثبت شد.', 'محصول با موفقیت ثبت شد.')
              this.$emit('refreshComponent')
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    async setComponentForm(mode = 'all') {
      let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
      document.getElementById(`language_item_${language_id}`).click();

      this.form.nameAndLink.link = this.$route.params.slug;
      this.$store
          .dispatch("Product/getDashboardProduct", this.form.nameAndLink.link)
          .then(async (res) => {

            res = res.data.data

            language_id = await res.language_id;
            document.getElementById(`language_item_${language_id}`).click();
            this.form.table = []
            this.form.keyWords = []
            if (mode === 'all') {

              this.form.nameAndLink.name = await res.name;
              this.form.id = await res.id;
              this.form.nameAndLink.link = await res.raw_link;
              this.form.published = await res.status ? true : false;
              this.form.mainPreview = await res.thumbnail;
              this.form.price = await res.price;
              this.form.bonus = await res.bonus;
              this.form.order = await res.order;
              this.form.quantity = await res.quantity;
              this.form.shippingCost = await res.delivery_amount;
              this.form.discount = await res.offer;
              this.form.is_digital = await res.is_digital == 1 ? true : false;
              this.form.variation = await res.variation;

              if (res.description == null) {
                this.form.description = "";
              } else {
                this.form.description = await res.description;
              }

              if (res.barcode == null) {
                this.form.barcode = "";
              } else {
                this.form.barcode = await res.barcode;
              }


              if (res.brand == null) {
                this.form.selectedBrand = '';
              } else {
                this.form.selectedBrand = await res.brand;

              }

              this.form.selectedCategory = []

              await res.category.forEach((category) => {
                this.form.selectedCategory.push(category)
              });

              this.form.features = await res.feature_product


              await res.images.forEach((image) => {
                this.form.preview.push(image.file);
              });


              await res.keywords.forEach((keyword) => {
                this.form.keyWords.push(keyword.keyword);
                this.form.table.push({name: keyword.keyword});
              });


              const crawlerForm = {
                crawlerable_id: res.id,
                crawlerable_type: 'product',
              }

              await this.$store.dispatch("Crawler/getCrawlers", crawlerForm);

              if (res.variation == 2) { // if product was timable
                const ReservationForm = {
                  product: res.id,
                  month: this.$store.getters['Reservation/getMonth'],
                  year: this.$store.getters['Reservation/getYear'],
                  withoutState: false,
                }

                let DashboardProductRules = await this.$store.dispatch("Reservation/getDashboardProductRules", ReservationForm);
                let reservationTimes = DashboardProductRules.data.data.reservation_times
                this.$store.commit('Reservation/setReservationTimes', reservationTimes)
              }

              if(res.variation == 0){
                this.calculatePercentOfDiscount()
              }


              const bulkForm = {
                product_id: res.id,
              }
              await this.$store.dispatch("Bulk/getBulks", bulkForm);

            }


            if (mode === 'image') {
              this.form.images = []
              this.form.preview = []
              await res.images.forEach((image) => {
                this.form.preview.push(image.file);
              });

              this.form.order = await res.order;

            }

          })
          .catch((err) => {
            // this.$router.push({name: "ProductsDashboard"});
            console.log(err);
          });
    },
    imageHandlerFunction(image) {
      this.form.description += image;
    },
    videoHandlerFunction(video) {
      this.form.description += video;
    },
    iframeHandlerFunction(iframe) {
      this.form.description += iframe;
    },
    removeImage() {
      this.setComponentForm('image')
    },
    setImages(value) {
      for (let i = 0; i < value.length; i++) {
        const file = value[i];
        this.form.images.push(file)
      }
    },
    removeTempImage(value) {
      this.form.images.splice(value, 1)
    },
    variationSwitchChange() {
      // if variation was change on update mode we save it to database.
      if (this.$route.params.slug !== undefined) {
        this.onSubmit();
      }
    },
    copyToClipBoard(value) {
      navigator.clipboard.writeText(value);
      toast('عملیات با موفقیت انجام شد', 'کپی شد.', 'success')
    },
    calculateDiscount() {
      // محاسبه تخفیف بر اساس درصد وارد شده و قیمت اصلی
      this.form.discount = (this.form.price * this.form.discountPercentage) / 100;
    },
    calculatePercentOfDiscount() {
      this.form.discountPercentage = (this.form.discount * 100) / this.form.price; // تنظیم درصد تخفیف به صفر
    },
  },
  async mounted() {
    await this.$store.dispatch("Category/getDashboardCategories");
    await this.$store.dispatch("Brand/getBrands");
    await this.$store.dispatch("Feature/getFeatures");
    const routerLink = this.$route.params.slug;
    if (routerLink !== undefined) {

      await this.setComponentForm()


    } else {
      let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
      document.getElementById(`language_item_${language_id}`).click();

    }
  },
  destroyed() {
    this.$store.commit('Reservation/setReservationRule', {})
  }
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>
